<template>
  <div id="app">
    <router-view />
    <theme-picker />
  </div>
</template>

<script>
import ThemePicker from "@/components/ThemePicker";

export default {
    name: "App",
    components: { ThemePicker },
    metaInfo() {
        return {
            title: this.$entryMenuName || (this.$store.state.settings.dynamicTitle && this.$store.state.settings.title),
            titleTemplate: title => {
                return title ? `${title}` : process.env.VUE_APP_TITLE
            }
        }
    },
    mounted(){
    

    },
    methods:{
       
    }
};
</script>
<style>
body,#app{
  /* height:1080px !important; */
}
#app .theme-picker {
  display: none;
}
#loader-wrapper .load_title span {
      font-weight: normal;
      font-style: italic;
      font-size: 13px;
      color: #FFF;
      opacity: 0.5;
    }
    #hintGlobal{
        z-index: 9999;
        position:fixed;
        left:0px;
        top:0px;
        display:flex;
        align-items: center;
        justify-content: center;
        width: 1919px;
        height: 1080px;
        background: rgba(0,28,28,0.3);
        backdrop-filter: blur(5px);
        display: none;
    }
    #hintGlobal>div{
        width: 560px;
        height: 300px;
        background: rgba(13,33,40,0.8);
        border-radius: 26px;
        border: 1px solid #2DBBAB;
        backdrop-filter: blur(0px);
        display:flex;
        flex-direction: column;
        align-items: center;
    }
    #hintGlobal>div h3{
        text-align: center;
        width: 560px;
        height: 61px;
        line-height: 61px;
        background: linear-gradient(180deg, rgba(66,226,216,0.5) 0%, #01B5A1 100%);
        border-radius: 26px 26px 0px 0px;
        backdrop-filter: blur(0px);
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
    }
    #hintGlobal div p{
        text-align: center;
        width: 340px;
        height: 40px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #E0E0E0;
        line-height: 40px;

    }
    #hintGlobal div p:nth-child(2){
        margin-top:61px;
        margin-bottom:46px;
    }
    #hintGlobal div p span{
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        background: #00E1D7;
        border-radius: 12px;
        color:black;
        font-weight: 800;
        margin-right:8px;
    }
    #hintGlobal>div>.button>#hintGlobalClose{
        display:inline-block;
        width:160px;
        height: 52px;
        line-height: 52px;
        text-align: center;
        border-radius: 28px;
        border: 1px solid #00E1D7;
        backdrop-filter: blur(0px);
        font-size: 20px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #00E1D7;
        margin: 0 20px;
        cursor:pointer;
    }

    #hintGlobal>div>.button>#hintGlobalDetermine{
        display:inline-block;
        width:160px;
        height: 52px;
        line-height: 52px;
        text-align: center;
        background: #2DBBAB;
        border-radius: 26px;
        font-size: 20px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #FFFFFF;
        margin: 0 20px;
        cursor:pointer;
    }

    .el-message{
        min-width: 8rem !important;
        max-width: 9.3333rem !important;
        padding: 0.15rem 0.2rem 0.15rem 0.2rem;
    }
</style>
